import React, {Fragment, useState} from 'react'
import MetaTags from 'react-meta-tags';
import SchemaProduct from './SchemaProduct';
import SchemaRecipe from './SchemaRecipe';
import {currentLang} from './../../../utils/functions';
import {siteInfo} from './../../../utils/config';
import {truncate} from 'lodash';

const Meta = ({type, title, description, robots, url, site_name, fbadmins, image, card, type_data}) => {
    const canonicalurl = window.location.origin+window.location.pathname.replace(/\/$/, "");
    return (
        <Fragment>
            <MetaTags>
                <title>{title+" | "+siteInfo[currentLang()]['title']}</title>
                <link rel="canonical" href={canonicalurl} ></link>
                <meta name="description" content={truncate(description, {'length':150})}/>
                {robots && <meta name="robots" content={robots} />}
                <meta property="og:locale" content={siteInfo[currentLang()]['locale']} /> 
                <meta property="og:type" content={type} /> 
                <meta property="og:title" content={title+" "+siteInfo[currentLang()]['title']+"!"}/> 
                <meta property="og:description" content={truncate(description, {'length':150})}/> 
                <meta property="og:url" content={canonicalurl}/> 
                <meta property="og:site_name" content={siteInfo[currentLang()]['domain']}/> 
                <meta property="fb:admins" content={siteInfo[currentLang()]['fbadmins']} /> 
                {image && <meta property="og:image" content={image}/> }
                <meta name="twitter:card" content={card ? card : "summary"} /> 
                <meta name="twitter:description" content={truncate(description, {'length':150})}/> 
                <meta name="twitter:title" content={siteInfo[currentLang()]['twtitle']+" "+title}/> 
                <meta name="twitter:site" content={siteInfo[currentLang()]['twitter']} /> 
                {image && <meta name="twitter:image" content={image}/> }
            </MetaTags>
            
            {type == "product" &&
                <SchemaProduct data={type_data} />
            }
            {type == "recipe" &&
                <SchemaRecipe data={type_data} />
            }
        </Fragment>
        
    )
}

export default Meta
